<template>
  <div class="contact">
    <main class="cf w-100 ph3 pv6 ph4-m ph5-ns pv6-ns" style="position:relative; z-index:1;">
      <p class="w-100 w-50-ns w-75-m f5 ml3-ns mt0">Fashion / portrait photographer based between Amsterdam and Tokyo<br>Graduated from Willem de Kooning Academy, Rotterdam, 2016 – Bachelor of Design</p>
      <p class="w-100 w-50-ns w-75-m f5 ml3-ns mt0"><br></p>
      <h2 class="w-100 w-50-ns w-75-m f5 ml3-ns">SELECTED CLIENTS</h2>
      <p class="w-100 w-50-ns w-75-m f5 ml3-ns">AVROTROS / BankGiro Loterij / Beefeater Gin / Driving Dutch Design / G-sus /<br>Jutka & Riska / Museumnacht / Studio MEN / TK Maxx</p>
      <p class="w-100 w-50-ns w-75-m f5 ml3-ns mt0"><br></p>
      <p class="w-100 w-50-ns w-75-m f5 ml3-ns"><a class="link underline black dib mr3 mr4-ns f5 outline-0" href="http://instagram.com/kimvanaalderen" target="_blank">@kimvanaalderen</a></p>
      <p class="w-100 w-50-ns w-75-m f5 ml3-ns">kim@kimvanaalderen.com</p>
    </main>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'contact',
  components: {
  }
}
</script>
